import { styled } from "@mui/material/styles";

export const ProfileContainer = styled("div")(({ theme }) => ({
  "& .form-actions": {
    display: "flex",
    justifyContent: "flex-end",
  },
  "& .form-section": {
    display: "flex",
    gap: "50px",
    width: "100%",
    marginBottom: "20px",
    // alignItems: "center",
    borderBottom: `rgba(255,255,255,.1) 1px solid`,
    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px"
    },
    "& > label": {
      color: "#D1C7FF",
      minWidth: "250px",
      maxWidth: "250px",
      fontSize: "14px",
      [theme.breakpoints.down("md")]: {
        minWidth: "150px",
        maxWidth: "100%"
      },
      [theme.breakpoints.down("sm")]: {
        minWidth: "0",
      },
      "& span": {
        display: "block",
        fontWeight: "normal",
        color: "#EAEAEA",
        marginTop: "5px"
      }
    },
    "&:nth-child(5)": {
      "& .field-group": {
        flexWrap: "wrap",
        flexDirection: "column",
        gap: "20px",
        "& .input-field.checkbox-field": {
          display: "flex",
          alignItems: "center",
          marginBottom: "0",
          "& label": {
            marginBottom: 0,
            fontSize: "12px",
            display: "flex",
            alignItems: "center"
          },
          "& input": {
            marginRight: "8px",
          }
        }
      }
    },
    "& .field-group": {
      display: "flex",
      gap: theme.spacing(2),
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
      "& > *": {
        flex: "1 1 0",
        minWidth: 0,
      },
      "& .help-text": {
        marginTop: "10px",
        fontSize: "14px",
        opacity: ".7",
      },
      "& .avatar-container": {
        display: "flex",
        gap: "15px",
        flex: "auto",
        "& .dropzone": {
          width: "100%"
        }
      }
    },
    "& .field-group-upload": {
      display: "flex",
      gap: theme.spacing(2),
      width: "100%",
    },
    "& .field-group-toggles .flipswitch": {
      marginBottom: "15px",
      "&:last-child": {
        marginBottom: 0
      }
    }
  },
}));
